import React from "react";
import { Dialog, DialogContent } from "@mui/material";
import { Button, Iconography, IconographySizes } from "@hid-galaxy-ui/galaxy-react";

type Props = {
  open: boolean;
  type: "category" | "benefit";
  itemName: string;
  onClose: () => void;
  onConfirm: () => void;
};

const DeleteBenefitsModal: React.FC<Props> = ({
  open,
  type,
  itemName,
  onClose,
  onConfirm,
}) => {
  const isCategory = type === "category";

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <div className="benefits-ptv-modal benefits-delete-modal">
        <header className="benefits-ptv-modal-header">
          <div className="benefits-delete-heading">
            <span className="benefits-delete-icon">
              <Iconography icon="circleExclamation" size={IconographySizes.Small} />
            </span>
            <h3>{isCategory ? "Delete category?" : "Delete benefit?"}</h3>
          </div>
        </header>
        <DialogContent className="benefits-ptv-modal-content">
          <p>
            Are you sure to delete <strong>&quot;{itemName}&quot;</strong>. This action cannot
            be undone.
          </p>
          <div className="benefits-warning-box" role="alert">
            <Iconography icon="circleExclamation" size={IconographySizes.Medium} />
            <div>
              <h4>Warning notification</h4>
              <p>
                {isCategory
                  ? "Deleting this category will remove all benefits mapped under this category."
                  : "Deleting this benefit will remove its tier mapping and details."}
              </p>
            </div>
          </div>
        </DialogContent>
        <footer className="benefits-ptv-modal-footer">
          <Button variant="secondary" label="CANCEL" onClick={onClose} />
          <Button variant="primary" label="DELETE" onClick={onConfirm} />
        </footer>
      </div>
    </Dialog>
  );
};

export default DeleteBenefitsModal;
